import type { NodeDisplayState } from '../EditorContext';
import { formatDuration } from '../canvasToolbar/RunHistorySheet.utils';

export interface NodeRunStats {
  readonly duration: string | null;
  readonly credits: string | null;
}

export const formatCredits = (credits: number): string => {
  if (credits > 0 && credits < 0.01) return '<0.01';
  return credits.toFixed(2);
};

/**
 * Elapsed time + credits spent for the Task node's footer row. Returns
 * null while the node has no finished attempt (idle / running / no data),
 * so the row only renders once there is something to report.
 */
export const resolveNodeRunStats = (
  runState: NodeDisplayState,
): NodeRunStats | null => {
  if (runState.status !== 'completed' && runState.status !== 'failed') {
    return null;
  }
  const duration =
    runState.executionTimeMs != null
      ? formatDuration(runState.executionTimeMs)
      : null;
  const credits =
    runState.creditsSpent != null ? formatCredits(runState.creditsSpent) : null;
  if (duration === null && credits === null) return null;
  return { duration, credits };
};
